import { areItemPricesEquivalent, getDefaultItemPrice, getDefaultItemPricesForParentSalesOptions, getItemById, getLowestItemPrice, getLowestItemPricesForParentSalesOptions, getMinMonetaryValue, isNormalItem, isParentSalesItem, multiplyMonetaryValue } from '@vista/omnichannel-components-domain';
export const getDisplayPrice = (sellableItem, displayText, priceDisplayText, priceFormat, i18n) => {
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Cannot get display price for item with ID: ${sellableItem.itemId}`);
    if (isNormalItem(item)) {
        return getFormattedPriceForSellableItem(sellableItem, priceDisplayText.itemPriceFormat, priceDisplayText.discountedPriceFormat, priceFormat, i18n);
    }
    if (isParentSalesItem(item)) {
        return getFormattedPriceForParentSalesItem(item, displayText.parentSalesItemButtonPriceLabel, i18n, priceFormat.showDefaultPrice);
    }
};
export const getFormattedPriceForSellableItem = (sellableItem, priceTemplate, discountedPriceTemplate, priceFormat, i18n, quantity) => {
    const { showDefaultPrice } = priceFormat;
    const itemPrice = showDefaultPrice
        ? getDefaultItemPrice(sellableItem.prices)
        : getLowestItemPrice(sellableItem.prices);
    if (!itemPrice)
        return;
    return getFormattedPrice(priceTemplate, discountedPriceTemplate, priceFormat, itemPrice.price, i18n, quantity);
};
export const getFormattedPrice = (priceTemplate, discountedPriceTemplate, discountedPriceFormat, price, i18n, quantity) => {
    const { applyDiscountedFormat } = discountedPriceFormat;
    const formattedPrice = i18n.monetaryValue(multiplyMonetaryValue(price, quantity || 1));
    const template = applyDiscountedFormat ? discountedPriceTemplate : priceTemplate;
    return i18n.template(template, {
        price: formattedPrice
    });
};
const getFormattedPriceForParentSalesItem = (item, template, i18n, showDefaultPrice) => {
    const itemPrices = showDefaultPrice
        ? getDefaultItemPricesForParentSalesOptions(item.options)
        : getLowestItemPricesForParentSalesOptions(item.options);
    if (areItemPricesEquivalent(itemPrices))
        return i18n.monetaryValue(itemPrices[0].price);
    if (showDefaultPrice)
        return;
    const minPrice = getMinMonetaryValue(itemPrices.map(itemPrice => itemPrice.price));
    return i18n.template(template, {
        minPrice: i18n.monetaryValue(minPrice)
    });
};
